import { siteConfigParser } from "../../../helpers/siteConfigParser";
export var getVideoRedirectLink = function (item) {
    var _a, _b, _c;
    var redirectLink = '';
    if (item === null || item === void 0 ? void 0 : item.gist) {
        var _d = item.gist, permalink = _d.permalink, watchedTime = _d.watchedTime, id = _d.id;
        var itemId = id;
        var watchedTimeQuery = watchedTime ? "?start=".concat(watchedTime) : '';
        redirectLink = "".concat(permalink).concat(watchedTimeQuery);
        if (window && siteConfigParser((_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.features, "showDetailToggle") && ((_c = item === null || item === void 0 ? void 0 : item.series) === null || _c === void 0 ? void 0 : _c.gist)) {
            watchedTimeQuery = watchedTime ? "&start=".concat(watchedTime) : '';
            redirectLink = "".concat(item.series.gist.permalink, "?v=").concat(id).concat(watchedTimeQuery);
        }
        // if (window && siteConfigParser(window.app_data, "showDetailToggle") && item.series && item.series.length > 0){
        //     watchedTimeQuery = watchedTime ? `&start=${watchedTime}` : '';
        //     redirectLink = `${item.series[0].gist.permalink}?v=${itemId}${watchedTimeQuery}`;
        // }
    }
    return redirectLink;
};
